<template>
  <card
    class="card-stats"
    :show-footer-line="true"
    v-bind:style="{ background: backGround }"
  >
    <b-row>
      <b-col md="11">
        <slot>
          <h5 class="card-title text-uppercase text-muted mb-0" v-if="title">
            {{ title }}
          </h5>
          <span class="h2 font-weight-bold mb-0 mr-3" v-if="catecumenos"
            >Catecumenos: {{ catecumenos }}</span
          >
          <span class="h2 font-weight-bold mb-0" v-if="nGrupos"
            >Grupos: {{ nGrupos }}</span
          >
        </slot>
      </b-col>
    </b-row>
    <p v-for="(item, index) in responsable" class="mb-0 text-sm" :key="index">
      <span class="text-nowrap">{{ montaResponsable(item) }}</span>
    </p>
  </card>
</template>
<script>
import Card from "./Card.vue";

export default {
  name: "stats-card",
  components: {
    Card,
  },
  props: {
    type: {
      type: String,
      default: "primary",
    },
    responsable: { type: Array, default: [] },
    icon: String,
    title: String,
    nGrupos: { type: Number, default: 0 },
    catecumenos: Number,
    iconClasses: [String, Array],
    backGround: String,
  },
  methods: {
    montaResponsable(element) {
      var text = "";
      if (element && element.nombre) {
        text = element.nombre;
      }
      if (element && element.apellido1) {
        text = text + " " + element.apellido1;
      }
      if (element && element.apellido2) {
        text = text + " " + element.apellido2;
      }
      return text;
    },
  },
};
</script>
<style>
.card-stats {
  cursor: pointer;
}
</style>
